module.exports = __webpack_public_path__ + "img/loginNoText.0b07bdeb.png";